import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

var localeMessages = loadLocaleMessages();

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}

    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })

    return messages
}

function getLocale() {
    let language = getLanguageFromUrl(window.location.hash);

    if(language != undefined) {
        return language;
    }

    const el = document.getElementsByClassName('decoupled-app-component')[0];

    if(el != undefined) {
        language = getLanguageFromUrl(el.getAttribute('metaurl'));
        if(language != undefined) {

            return language;
        }
    }

    return process.env.VUE_APP_I18N_LOCALE || "nl_NL"
}

function getLanguageFromUrl(url) {
    if(!url || url == undefined){
        return undefined;
    }

    const pathArray = url.split('/');
    const locale  = pathArray[1];
    const locales = (Object.keys(localeMessages));

    if (locales.includes(locale)) {
        return locale
    }

    return undefined;
}

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'nl_NL',
  messages: localeMessages
})
